import React from 'react';
import { Link } from 'react-router-dom';

const RecipeCard = ({ recipe }) => {
  if (!recipe) return null;

  const { id, title, description, image, prepTime, cookTime, category, difficulty, foodRecipes } = recipe;

  return (
    <div className="recipe-card">
      <Link to={id === 5 ? `/food-card/${id}` : `/recipe/${id}`} state={recipe}>
        <div className="recipe-image">
          <img src={image} alt={title} />
        </div>
        <div className="recipe-content">
          <h3>{title}</h3>
          <div className="recipe-meta">
          </div>
        </div>
      </Link>

      <style jsx>{`
        .recipe-card {
          background-color: var(--white);
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        
        .recipe-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
        }
        
        .recipe-image {
          position: relative;
          height: 200px;
        }
        
        .recipe-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        
        .recipe-category {
          position: absolute;
          top: 15px;
          right: 15px;
          background-color: var(--primary-color);
          color: white;
          padding: 5px 10px;
          border-radius: 20px;
          font-size: 0.8rem;
          text-transform: capitalize;
        }
        
        .recipe-content {
          padding: 1.5rem;
        }
        
        .recipe-content h3 {
          font-size: 1.2rem;
          margin-bottom: 0.7rem;
          transition: color 0.3s ease;
        }
        
        .recipe-card:hover .recipe-content h3 {
          color: var(--primary-color);
        }
        
        .recipe-content p {
          color: var(--gray);
          font-size: 0.9rem;
          margin-bottom: 1rem;
          line-height: 1.5;
        }
        
        .recipe-meta {
          display: flex;
          justify-content: space-between;
          font-size: 0.9rem;
          color: var(--gray);
        }
        
        .recipe-time, .recipe-difficulty {
          display: flex;
          align-items: center;
        }
        
        .recipe-time svg, .recipe-difficulty svg {
          margin-right: 5px;
          color: var(--primary-color);
        }
      `}</style>
    </div>
  );
};

export default RecipeCard;
